import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import SiteLayout from "./components/SiteLayout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import BookingPage from "./pages/BookingPage";
import PaymentResult from "./pages/PaymentResult";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
          <Route path="/services" element={<SiteLayout><Services /></SiteLayout>} />
          <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
          <Route path="/book" element={<SiteLayout><BookingPage /></SiteLayout>} />
          <Route path="/payment-result" element={<SiteLayout><PaymentResult /></SiteLayout>} />
          <Route path="/admin/login" element={<SiteLayout><AdminLogin /></SiteLayout>} />
          <Route path="/admin" element={<SiteLayout><AdminDashboard /></SiteLayout>} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#292524",
            border: "1px solid #44403c",
            color: "#fafaf9",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
